import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {doctorSpecilaities} from 'src/app/_models/specialities.model'

@Injectable({
  providedIn: 'root'
})
export class DoctorSpecilaitiesService {


  specialitiesUrl =  'api/DoctorSpeciality';

  constructor(private http: HttpClient) {}

  getAllSpecialities(): Observable<any> {
    return this.http.get(`${this.specialitiesUrl}/GetAllSpecialities`);
  }
}
